import { z } from 'zod';

import { UserRole } from './user-role';

/**
 * Represent the shape of user record as stored in the database.
 */
export const dbUserSchema = z.object({
  pk: z.literal('users'),
  sk: z.string(),
  id: z.string(),

  createdAt: z.string(),
  updatedAt: z.string(),

  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  role: z.enum([UserRole.Admin, UserRole.Superadmin, UserRole.User]),
  teams: z.array(z.number()).optional(),
  tenantId: z.string(),
});

export type DbUser = z.infer<typeof dbUserSchema>;
